import { SvgProps } from "../../types";

export default function SaveCheckIcon({ stroke }: SvgProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke={stroke || "currentColor"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-check"
        >
            <polyline points="20 6 9 17 4 12" />
        </svg>
    );
}
